import {BaseContainerModel} from '../base-container.model';
import {bl_applet_module_hdr_RowClass} from '../../dbschema';

export class AppletModuleHdrModel extends BaseContainerModel {
  bl_applet_module_hdr: bl_applet_module_hdr_RowClass = new bl_applet_module_hdr_RowClass();
}
